module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          directives: [{
            name: "ripple",
            rawName: "v-ripple"
          }],
          staticClass: "contact-avatar clickable",
          style: (_vm.imageStyle)
        }, on), [_vm._v("\n            " + _vm._s(_vm.initials) + "\n        ")])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.contact && _vm.contact.image && _vm.size < 35) ? _c('img', {
    staticStyle: {
      "width": "40px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.contact.image
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fullName))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50eee856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/ui/ContactImage.vue
// module id = 2544
// module chunks = 1